<template>
    <div class="check-in__inner ">
        <div class="check-in__data">
            <div class="check-in__top d-flex justify-space-between">
                <div class="check-in__wrapper d-flex  align-center">
                    <div class="check-in__ico">
                        <svg-icon name="passcode"></svg-icon>
                    </div>
                    <div class="check-in__info font-medium">
                        {{$t('studio.check-in.passcode_is')}}: <b class="font-semi">{{getCheckinData.pass_code}}</b>
                    </div>
                </div>
                <div class="check-in__wrapper d-flex  align-center">
                    <div class="check-in__ico">
                        <svg-icon name="studio"></svg-icon>
                    </div>
                    <div class="check-in__info font-medium">
                        {{$t('studio.check-in.studio_is')}}: <b class="font-semi">{{getCheckinData.studio_name}}</b>
                    </div>
                </div>
            </div>
            <div class="check-in__body d-flex justify-space-between align-center">
                <div class="check-in__item d-flex justify-center align-center"
                     v-for="(value, key) in getCheckinList"
                     :key="key"
                     :class="value ? 'is-success' : 'is-error'"
                >
                    <div class="check-in__img">
                        <img :src="getImgUrl(value)" alt="">
                    </div>
                    <div class="check-in__title">
                        {{$t(`studio.check-in.status.${key}`)}}
                    </div>
                    <div class="check-in__status">
                        {{getStatus(key,value)}}
                    </div>
                </div>
            </div>
        </div>
        <div class="check-in__action d-flex justify-center align-center">
            <button
                    :disabled="isAvaibleButton"
                    class="btn btn-m btn-gradient"
                    @click="checkInHandler"
            >
                <span>
                    {{$t('studio.check-in.button_check_in')}}
                </span>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            getStatus(name, state) {
                name = name.toLowerCase();
                let status;
                switch (name) {
                    case 'credit':
                    case 'action_participants':
                        status = state ? this.$t("studio.check-in.status.sufficient") : this.$t("studio.check-in.status.insufficient");
                        break;
                    case 'authorization':
                        status = state ? this.$t("studio.check-in.status.yes") : this.$t("studio.check-in.status.no");
                        break;
                    case 'contracts':
                        status = state ? this.$t("studio.check-in.status.active") : this.$t("studio.check-in.status.inactive");
                        break;
                    default:
                        break;
                }
                return status;
          },
            getImgUrl(state) {
                let type = state ? 'success' : 'error';
                let images = require(`@/assets/images/check-in/${type}.svg`)
                return images;
            },
            async checkInHandler() {
                try {
                    let response = await this.$store.dispatch("PASS_CODE_CHECK_IN", {code: this.getCheckinData.pass_code})
                    if(response && response.status === 200) {
                        let transaction_id = response.data.data.transaction.id;
                        this.isSuccess(transaction_id)
                    }

                }catch(e) {
                    console.log(e, 'hello world')
                }
            },
            isSuccess(transaction_id) {
                this.$emit('success', transaction_id)
            },

        },
        computed: {
            getCheckinData() {
                return this.$store.getters.getCheckinData
            },
            getCheckinList() {
                let {credit, action_participants, contracts} =  this.getCheckinData;
                let data = {
                    credit: credit,
                    authorization: (!credit || !contracts) ? false : true,
                    action_participants: action_participants,
                    contracts: contracts
                }
                return data
            },
            isAvaibleButton() {
                let obj = this.getCheckinList;
                const allTrue = Object.keys(obj).every((k) => obj[k]);
                return !allTrue;
            },
        }
    }
</script>
<style lang="sass" scoped>
    .check-in
        &__data
            padding: 32px 40px
            background: #FFFFFF
            box-shadow: 0px 8px 14px rgba(11, 35, 75, 0.11)
            border-radius: 4px
            +r(959)
                padding: 32px
            +xs
                padding: 0
        &__top
            padding-bottom: 28px
            +r(959)
                flex-direction: column
            +xs
                padding-bottom: 0
        &__wrapper
            &:last-of-type
                +r(959)
                    margin-top: 24px
                +xs
                    margin-top: 0
                    border-top: 1px solid rgba(#01254E, 0.12)
        &__body
            padding-top: 34px
            border-top: 1px solid rgba(1, 37, 78, 0.1)
            +sm
                flex-direction: column
            +xs
                padding: 32px
        &__info
            font-size: 14px
            margin-left: 8px
        &__ico
            width: 46px
            height: 46px
            position: relative
            background: rgba($color--dark, 0.06)
            border-radius: 2px
            position: relative
            +xs
                width: 64px
                height: 60px
                margin-right: 20px
                &:before
                    content: ""
                    width: 0
                    z-index: 0
                    height: 0
                    border-left: 15px solid rgba(11, 35, 75, 0.06)
                    border-top: 30px solid transparent
                    border-bottom: 30px solid transparent
                    position: absolute
                    top: 0
                    left: 100%
            svg
                +vcenter
            .icon-passcode
                fill: none
                stroke: rgba(#939EAF,0.7)
            .icon-studio
                width: 33px
                height: 27px
                stroke: none
                fill: none
        &__item
            display: flex
            flex-direction: column
            +reg
            &.is-success
                .check-in__status
                    color: $color--green
            &.is-error
                .check-in__status
                    color: $color--red
            +sm
                &:not(:first-of-type)
                    margin-top: 24px
        &__title
            text-transform: uppercase
            color: rgba($color--dark, 0.5)
            letter-spacing: 0.5px
            font-size: 18px
            line-height: 25px
            margin: 8px 0 2px 0
        &__img
            width: 32px
            height: 32px
        &__status
            +tr(color .3s ease)
            font-size: 14px
        &__action
            margin-top: 40px
</style>
